// extracted by mini-css-extract-plugin
export default {"focus":"SensorStatusFocus_focus__s7XOq"};